import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Layout,
  Col,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Spin,
} from "antd";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";
import { staticConfig } from "../glAndAccounting.config";

const { Text, Title } = Typography;

const AddSubLedgerGLA0100 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { state } = useLocation();

  const { newGLItems, statusData } = appStatic;

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [useForm] = Form.useForm();
  const [glAccTemplate, setGlAccTemplate] = useState({});

  useEffect(() => {
    getTemplate();
  }, []);

  function onCancel() {
    navigate("/view-gla0100", { state: state });
  }

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        setGlAccTemplate(res);
        let tempAccountType = [];
        let tempAccountUsage = [];
        let tempParent = [];
        let tempAccountTag = [];
        let tempCurrency = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.usageOptions?.forEach((element) => {
          tempAccountUsage.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.assetHeaderAccountOptions?.forEach((element) => {
          tempParent.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.allowedAssetsTagOptions?.forEach((element) => {
          tempAccountTag.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        useForm.setFieldsValue({
          type: objList?.accountTypeOptions[0].id,
        });

        setAccountTypeData(tempAccountType);
        setAccountUsageData(tempAccountUsage);
        setParentData(tempParent);
        setAccountTagData(tempAccountTag);
        setCurrencyData(tempCurrency);
        setIsLoading(false);
      }
    });
  }

  const handleAccTypeChange = (value, option) => {
    switch (option?.label.toLowerCase()) {
      case "asset":
        assignParentData("assetHeaderAccountOptions");
        break;

      case "liability":
        assignParentData("liabilityHeaderAccountOptions");
        break;

      case "equity":
        assignParentData("equityHeaderAccountOptions");
        break;

      case "expense":
        assignParentData("expenseHeaderAccountOptions");
        break;

      case "income":
        assignParentData("incomeHeaderAccountOptions");
        break;

      default:
        assignParentData("assetHeaderAccountOptions");
        break;
    }
  };
  const assignParentData = (headerAccountParam) => {
    let tempParent = [];
    glAccTemplate[headerAccountParam]?.forEach((element) => {
      tempParent.push({
        value: element.id,
        label: element.name,
      });
    });
    setParentData(tempParent);
  };

  const onSubmit = (formValues) => {
    formValues.manualEntriesAllowed = manualEntriesAllowed;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.NewGlAccount, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
        navigate("/gla0100");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={appLabel.newSubLedgerAccount}
        pageItems={newGLItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="type"
                    label={<Text strong>{appLabel.accountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountType),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountType
                      )}
                      showSearch
                      options={accountTypeData}
                      onChange={handleAccTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="parentId"
                    label={<Text strong>{appLabel.parent}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.parent)}
                      showSearch
                      options={parentData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="glCode"
                    label={<Text strong>{appLabel.GLCode}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.GLCode),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(appLabel.GLCode)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{appLabel.accountName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountName),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountName
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="usage"
                    label={<Text strong>{appLabel.accountUsage}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountUsage),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountUsage
                      )}
                      showSearch
                      options={accountUsageData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="tagId"
                    label={<Text strong>{appLabel.tag}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.tag)}
                      showSearch
                      options={accountTagData}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{appLabel.manualEntriesAllowed}</Text>}
                    name="manualEntriesAllowed"
                  >
                    <Select
                      options={staticConfig.yesOrNo}
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.manualEntriesAllowed
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="status"
                    label={<Text strong>{appLabel.status}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.status),
                      },
                    ]}
                  >
                    <Select
                      options={statusData}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.status)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="currencyCode"
                    label={<Text strong>{appLabel.currency}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.currency)}
                      options={currencyData}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="description"
                    label={<Text strong>{appLabel.description}</Text>}
                  >
                    <TextArea
                      showCount
                      maxLength={100}
                      placeholder="Enter Account description"
                      style={{
                        height: 120,
                        resize: "none",
                      }}
                    ></TextArea>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSubLedgerGLA0100);
